import { Api } from './base/api';
export class WebLarekAPI extends Api {
    constructor(cdn, baseUrl, options) {
        super(baseUrl, options);
        this.cdn = cdn;
    }
    getProductList() {
        return this.get('/product').then((data) => data.items.map(item => (Object.assign(Object.assign({}, item), { image: this.cdn + item.image.replace(/\.\w+$/, '.png') }))));
    }
    postOrder(order) {
        return this.post('/order', order).then((data) => data);
    }
}
